<template>
    <div
        id="brands"
        class="cabinet-settings cabinet-settings-brands__wrap supplier-tab hide"
        data-title="Информация о брендах"
    >
        <div class="cabinet-settings-brands flex">
            <div class="cabinet-settings-brands__sidebar">
                <div class="cabinet-settings-brands__sidebar-title">
                    Ваши бренды
                </div>
                <div
                    v-if="errors.brands"
                    class="cabinet-settings-brands__links"
                >
                    {{ errors.brands }}
                </div>
                <div v-else class="cabinet-settings-brands__links">
                    <template v-if="brands.length">
                        <a
                            v-for="brand in brands"
                            :key="brand.BrandID"
                            href="javascript:void(0)"
                            class="cabinet-settings-brands__link"
                            :class="{ active: activeBrand == brand.BrandID }"
                            @click="onSupplierBrandsClick(brand.BrandID)"
                        >
                            {{ brand.BrandName }}
                        </a>
                    </template>
                    <div v-else>Нет брендов</div>
                    <div class="cabinet-form-group">
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--add cabinet-btn--add-white cabinet-settings-brands__link--js"
                            @click="openCreateBrand()"
                        >
                            Добавить бренд
                        </button>
                    </div>
                </div>
            </div>
            <!-- /cabinet-settings-brands__sidebar -->

            <supplier-brand v-if="activeBrand >= 0" />

            <create-brand
                :is-open="isCreateBrandModalOpen"
                @closeModal="closeCreateBrandModal"
                @createBrandSaved="onCreateBrandSaved"
            />
        </div>
    </div>
</template>

<script>
import SupplierBrand from '@/components/Cabinet/Supplier/Settings/Brand'
import CreateBrand from '@/components/Cabinet/Supplier/Settings/CreateBrand'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'SupplierBrands',
    components: { SupplierBrand, CreateBrand },
    data() {
        return {
            loading: false,
            isCreateBrandModalOpen: false
        }
    },
    computed: {
        ...mapState('supplierBrand', ['brands', 'errors', 'activeBrand'])
    },
    mounted() {
        this.getBrandsList()
    },
    methods: {
        ...mapActions('supplierBrand', ['getBrands']),
        ...mapMutations('supplierBrand', ['SET_ACTIVE_BRAND', 'SET_ERRORS']),
        async getBrandsList() {
            this.SET_ERRORS({
                key: 'updateBrand',
                val: {}
            })

            await this.getBrands()

            if (this.brands.length && window.innerWidth > 767) {
                this.SET_ACTIVE_BRAND(this.brands[0].BrandID)
            }
        },
        onSupplierBrandsClick(id) {
            this.SET_ACTIVE_BRAND(id)
            this.SET_ERRORS({
                key: 'updateBrand',
                val: {}
            })

            if (window.innerWidth <= 767) {
                window.$('#supplier-cabinet-header-m').addClass('hide')
                window
                    .$('#supplier-cabinet-header-brands-m')
                    .removeClass('hide')

                window.$('.cabinet-settings-brands__sidebar').addClass('hide')
            }
        },
        openCreateBrand() {
            this.isCreateBrandModalOpen = true
        },
        closeCreateBrandModal() {
            this.isCreateBrandModalOpen = false
        },
        onCreateBrandSaved() {
            this.closeCreateBrandModal()
            this.onSupplierBrandsClick(this.activeBrand)
        }
    }
}
</script>
